<template>
    <v-container v-click-outside="{ handler: onClickOutside, include }" fluid class="mx-0 px-0">
        <v-navigation-drawer
            v-model="drawer"
            fixed
            class="drawer pt-12"
            :width="drawer? '170px' : '60px'"
        >
            <v-list
                nav
                dense
            >
                <div v-for="(menuItem, index) in filteredMenu" :key="index" @click="setDrawer">
                    <v-list-item :to="menuItem.to" link>
                        <v-list-item-icon v-if="menuItem.icon">
                            <v-icon>{{ menuItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-if="menuItem.title">{{ menuItem.title }}</v-list-item-title>
                    </v-list-item>
                </div>
            </v-list>
        </v-navigation-drawer>
    </v-container>
</template>

<script>
    export default {
        name: 'Sidebar',
        data() {
            return {
                menu: [
                    {
                        title: 'Arenas',
                        to: '/arenas',
                        icon: 'mdi-stadium-outline',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Matches',
                        to: '/matches',
                        icon: 'mdi-gamepad-variant-outline',
                        roles: ['ROLE_ADMIN', 'ROLE_STATS']
                    },
                    {
                        title: 'Cup',
                        to: '/cups',
                        icon: 'mdi-trophy',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Leagues',
                        to: '/leagues',
                        icon: 'mdi-podium-gold',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'League Groups',
                        to: '/league-groups',
                        icon: 'mdi-group',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Seasons',
                        to: '/seasons',
                        icon: 'mdi-calendar',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Teams',
                        to: '/teams',
                        icon: 'mdi-account-group-outline',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Players',
                        to: '/players',
                        icon: 'mdi-account-outline',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Articles',
                        to: '/articles',
                        icon: 'mdi-newspaper-variant',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Philosophy',
                        to: '/philosophy/edit',
                        icon: 'mdi-book-variant',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Regulation',
                        to: '/regulation/edit',
                        icon: 'mdi-abacus',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Faqs',
                        to: '/faqs',
                        icon: 'mdi-frequently-asked-questions',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Rules',
                        to: '/rules',
                        icon: 'mdi-police-badge-outline',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Team Applications',
                        to: '/team-applications',
                        icon: 'mdi-application-import',
                        roles: ['ROLE_ADMIN']
                    }
                ]
            }
        },
        computed: {
            drawer: {
                get() {
                    return this.$store.getters.getDrawer
                },
                set(value) {
                    return value
                }
            },
            // Filter menu items by roles: show item when it has no roles OR the user has at least one required role
            filteredMenu() {
                return this.menu.filter(menuItem => {
                    if (!menuItem.roles || !menuItem.roles.length) return true
                    const roles = this.$store.getters.getUserRoles
                    if (!roles || !roles.length) return false
                    return menuItem.roles.some(r => roles.includes(r))
                })
            }
        },
        methods: {
            onClickOutside() {
                this.setDrawer()
            },
            setDrawer() {
                if (this.drawer) {
                    this.$store.dispatch('setDrawer', !this.drawer)
                }
            },
            include() {
                return [document.querySelector('.included')]
            }
        }
    }
</script>

<style scoped>

a {
    color: #0060B6;
    text-decoration: none;
}

a:hover {
    color:#00A0C6;
    text-decoration:none;
    cursor:pointer;
}
.sub-text{
    font-size: 0.8rem;
    color: black;
}
.container {
    align-self: center;
    height: 100%;
}
</style>
